import StyledLikeList from "containers/LikeList/LikeList.styled";

const LikePost = () => {
  return (
    <>
      <StyledLikeList />
    </>
  );
};

export default LikePost;
